import { render, staticRenderFns } from "./popup-do-huamingce.vue?vue&type=template&id=68918d53&scoped=true"
import script from "./popup-do-huamingce.vue?vue&type=script&lang=js"
export * from "./popup-do-huamingce.vue?vue&type=script&lang=js"
import style0 from "./popup-do-huamingce.vue?vue&type=style&index=0&id=68918d53&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68918d53",
  null
  
)

export default component.exports